export default "__VITE_ASSET__C$xfLCgt__"